// SPDX-License-Identifier: AGPL-3.0-or-later

import {Limits} from '@app/features/app/utils/UserLimits';
import Users from '@app/features/user/state/Users';
import {MAX_FAVORITE_MEMES_PREMIUM} from '@fluxer/constants/src/LimitConstants';
import {msg, plural} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import {GenericErrorModal} from './GenericErrorModal';

const SAVED_MEDIA_LIMIT_REACHED_DESCRIPTOR = msg({
	message: 'Saved media limit reached',
	comment: 'Short label in the max favorite memes modal.',
});
const YOU_VE_REACHED_THE_MAXIMUM_LIMIT_OF_THIS_DESCRIPTOR = msg({
	message: "You're at the cap of {freeItemsText} — your instance admin sets this limit.",
	comment: 'Modal body shown when the favorite-memes limit is reached. Limit text is interpolated.',
});

export const MaxFavoriteMemesModal = observer(() => {
	const {i18n} = useLingui();
	const currentUser = Users.currentUser;
	const maxFavoriteMemes =
		currentUser?.maxFavoriteMemes ?? Limits.getPremiumValue('max_favorite_memes', MAX_FAVORITE_MEMES_PREMIUM);
	const freeItemsText = plural(
		{count: maxFavoriteMemes},
		{
			one: '# saved media item',
			other: '# saved media items',
		},
	);
	return (
		<GenericErrorModal
			title={i18n._(SAVED_MEDIA_LIMIT_REACHED_DESCRIPTOR)}
			message={i18n._(YOU_VE_REACHED_THE_MAXIMUM_LIMIT_OF_THIS_DESCRIPTOR, {freeItemsText})}
			data-flx="app.max-favorite-memes-modal.confirm-modal"
		/>
	);
});
